module.exports = __webpack_public_path__ + "public/Icons/referIcon.png?b3a50672";